// extracted by mini-css-extract-plugin
export default {"phoneCall":"PhoneCall_phoneCall__+hfTY","invalidNumber":"PhoneCall_invalidNumber__N2QEf","callIcon":"PhoneCall_callIcon__DYyvR"};